exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1-ZZBYH26jQMQkzipQF9vc{position:absolute;bottom:10px}html[dir=ltr] ._1-ZZBYH26jQMQkzipQF9vc{right:218px}html[dir=rtl] ._1-ZZBYH26jQMQkzipQF9vc{left:218px}", ""]);

// exports
exports.locals = {
	"fileIcon": "_1-ZZBYH26jQMQkzipQF9vc"
};